module.exports = __webpack_public_path__ + "85add4d7cea4e4155a4acc1821d98730.svg";